/**
 * [Vue.store.state.pageInfo.totalPageCountを使用しない理由]
 * 例）
 * 1ページあたりの表示件数(countPerPage) 2
 * 合計件数(totalCount) 5
 *
 * 最終ページデータ取得（最後の１件取得）
 * params {
 *  first: null,
 *  last: 1,
 *  before: null,
 *  after: null
 * }
 * 期待値 totalPageCount = 3
 * 実際値 totalPageCount = 5
 * countPerPage が 1 と認識され totalPageCount が 5 になってしまう
 */
import Vue from 'vue'

export default {
  data() {
    return {
      params: {
        first: null,
        last: null,
        before: null,
        after: null,
      },
      optionParams: null,
      countPerPage: 10,
      currentPageNumber: 1,
      totalCount: 0,
    }
  },
  computed: {
    hasPreviousPage: function () {
      return 1 < this.currentPageNumber
    },
    hasNextPage: function () {
      return this.currentPageNumber < this.totalPageCount
    },
    totalPageCount() {
      return Math.ceil(this.totalCount / this.countPerPage)
    },
  },
  methods: {
    initialize() {
      this.params = {
        first: null,
        last: null,
        before: null,
        after: null,
      }
    },
    moveFront() {
      this.currentPageNumber = 1
      this.params.first = this.countPerPage
      this.$apollo.provider.defaultClient.cache.reset()
    },
    movePrevious() {
      this.currentPageNumber--
      this.params.last = this.countPerPage
      this.params.before = Vue.store.state.pageInfo.startCursor
      this.$apollo.provider.defaultClient.cache.reset()
    },
    moveNext() {
      this.currentPageNumber++
      this.params.first = this.countPerPage
      this.params.after = Vue.store.state.pageInfo.endCursor
      this.$apollo.provider.defaultClient.cache.reset()
    },
    moveLast() {
      this.currentPageNumber = this.totalPageCount
      this.params.last = this.lastPageCount()
      this.$apollo.provider.defaultClient.cache.reset()
    },
    execute() {
      if (this.optionParams) {
        Object.assign(this.params, this.optionParams)
      }
      this.$apollo.provider.defaultClient.cache.reset()
    },
    movePage(type) {
      this.initialize()
      if (type == 'front') {
        this.moveFront()
      } else if (type == 'previous') {
        this.movePrevious()
      } else if (type == 'next') {
        this.moveNext()
      } else if (type == 'last') {
        this.moveLast()
      }
      this.execute()
    },
    lastPageCount() {
      return this.totalCount - (this.totalPageCount - 1) * this.countPerPage
    },
  },
}
